module.exports = __webpack_public_path__ + "img/head2.1261efbb.png";